var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{ref:"modalVerImagen",attrs:{"titulo":"Adjunto","tamano":"modal-xl"}},[_c('div',{staticClass:"image-viewer text-center"},[_c('img',{staticStyle:{"max-width":"100%","max-height":"calc(100vh - 300px)"},attrs:{"src":_vm.adjunto,"alt":"image-viewer"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }